@if (success()) {
<div class="success-state" role="status" data-testid="qualified-enquiry-success">
  <h3>Thank you — your project details have been received.</h3>
  <p>
    I will review the intended use, website and requested result flow. You will receive a personal reply with any necessary questions and
    the most practical next step.
  </p>
</div>
} @else {
<form class="enquiry-form" [formGroup]="form" (ngSubmit)="submit()" novalidate data-testid="qualified-enquiry-form">
  @if (attempted() && form.invalid) {
  <div #errorSummary class="error-summary" tabindex="-1" role="alert" aria-labelledby="error-summary-title">
    <h3 id="error-summary-title">Please check the highlighted fields</h3>
    <ul>
      @if (hasError('name')) {
      <li><a href="#enquiry-name">Enter your name</a></li>
      } @if (hasError('email')) {
      <li><a href="#enquiry-email">Enter a valid email</a></li>
      } @if (hasError('website')) {
      <li><a href="#enquiry-website">Enter a full website URL beginning with http:// or https://</a></li>
      <li><a href="#enquiry-wheel-count">Choose how many configurations you need</a></li>
      } @if (hasError('projectDetails')) {
      <li><a href="#enquiry-details">Enter at least 40 characters about your project</a></li>
      }
    </ul>
  </div>
  } @if (submissionFailed()) {
  <div class="submission-error" role="alert">Your details could not be sent. Please try again; your entries have been kept.</div>
  }

  <div class="field">
    <label for="enquiry-name">Name <span aria-hidden="true">*</span></label>
    <input
      id="enquiry-name"
      type="text"
      formControlName="name"
      autocomplete="name"
      [attr.aria-invalid]="hasError('name')"
      [attr.aria-describedby]="hasError('name') ? 'enquiry-name-error' : null"
    />
    @if (hasError('name')) {
    <p id="enquiry-name-error" class="field-error">Enter your name.</p>
    }
  </div>

  <div class="field">
    <label for="enquiry-email">Email <span aria-hidden="true">*</span></label>
    <input
      id="enquiry-email"
      type="email"
      formControlName="email"
      autocomplete="email"
      [attr.aria-invalid]="hasError('email')"
      [attr.aria-describedby]="hasError('email') ? 'enquiry-email-error' : null"
    />
    @if (hasError('email')) {
    <p id="enquiry-email-error" class="field-error">Enter a valid email address.</p>
    }
  </div>

  <div class="field field--wide">
    <label for="enquiry-website">Website </label>
    <input id="enquiry-website" type="url" formControlName="website" placeholder="https://example.com" />
  </div>

  <div class="field field--wide">
    <label for="enquiry-details">Tell me briefly about the project <span aria-hidden="true">*</span></label>
    <textarea
      id="enquiry-details"
      formControlName="projectDetails"
      rows="6"
      maxlength="1200"
      placeholder="Who will complete it, which categories you have in mind, and where it should appear on your website."
      [attr.aria-invalid]="hasError('projectDetails')"
      [attr.aria-describedby]="hasError('projectDetails') ? 'enquiry-details-error enquiry-character-count' : 'enquiry-character-count'"
    ></textarea>
    <p id="enquiry-character-count" class="character-count" aria-live="polite">
      {{ form.controls.projectDetails.value.length }} / 1200 characters
    </p>
    @if (hasError('projectDetails')) {
    <p id="enquiry-details-error" class="field-error">Enter between 40 and 1200 characters.</p>
    }
  </div>

  <div class="honeypot" aria-hidden="true">
    <label for="enquiry-nickname">Nickname</label
    ><input id="enquiry-nickname" type="text" formControlName="nickname" tabindex="-1" autocomplete="off" />
  </div>

  <div class="form-actions field--wide">
    <button type="submit" class="submit-button" [disabled]="pending()" data-testid="qualified-enquiry-submit">
      {{ pending() ? "Sending…" : "Send My Project Details" }}
    </button>
    <p>I will review the use case and website before suggesting a scope. Submitting the form does not commit you to a purchase.</p>
  </div>
</form>
}
